import type { InstallableLocale } from "../../i18n/preparedLocales";
import { useWorkspaceCopy } from "../../i18n/workspaceCatalog";
import { formatMessage, type MessageValues } from "../../i18n/catalogUtils";
export const MANAGED_SIGNING_EXPERIENCE_MESSAGES = {
  "en": {
    "releaseSigning": "Release signing",
    "evidenceWrapping": "Evidence wrapping",
    "description": "Manage Collector Release Ed25519 signing identities. TUF role activation is separate.",
    "generate": "Generate staged identity",
    "activate": "Activate",
    "retire": "Retire signer",
    "eligibility": "Check revoke eligibility",
    "retireTitle": "Retire this signer?",
    "retireBody": "New signing stops. Historical Collector Releases remain verifiable; public trust is preserved.",
    "retireReason": "Retirement reason",
    "confirmRetire": "Confirm retirement",
    "revokeTitle": "Remove public verification trust?",
    "revokeBody": "Revocation removes public verification trust. It requires a clear dependency check and recent MFA; it is not routine rotation.",
    "revokeReason": "Revocation reason",
    "ack": "I understand this removes public verification trust and is not routine key rotation.",
    "confirmRevoke": "Confirm revocation",
    "blocked": "Revocation is blocked",
    "clear": "Revocation dependency check is clear",
    "dependencyCount": "Dependent releases: {count}",
    "rotationBody": "Generate → Activate → Verify successor through Add Collector → Retire predecessor. Historical verification trust remains.",
    "staged": "STAGED",
    "retired": "RETIRED",
    "revoked": "REVOKED",
    "revocationPending": "REVOCATION PENDING",
    "recoveryPending": "RECOVERY PENDING",
    "empty": "No Collector Release signing identities yet.",
    "changed": "Signing identity updated.",
    "error": "The signing operation could not be completed.",
    "cancel": "Cancel",
    "generateTitle": "Generate staged identity?",
    "activateTitle": "Activate this signer?"
  },
  "fa": {
    "releaseSigning": "امضای انتشار",
    "evidenceWrapping": "محافظت از کلید شواهد",
    "description": "هویت‌های امضای Ed25519 انتشار کالکتور را مدیریت کنید. فعال‌سازی نقش‌های TUF جداست.",
    "generate": "ساخت هویت آمادهٔ فعال‌سازی",
    "activate": "فعال‌سازی",
    "retire": "بازنشسته کردن امضاکننده",
    "eligibility": "بررسی امکان ابطال",
    "retireTitle": "این امضاکننده بازنشسته شود؟",
    "retireBody": "امضای جدید متوقف می‌شود. انتشارهای قبلی کالکتور با حفظ اعتماد عمومی قابل تأیید می‌مانند.",
    "retireReason": "دلیل بازنشستگی",
    "confirmRetire": "تأیید بازنشستگی",
    "revokeTitle": "اعتماد به کلید عمومی حذف شود؟",
    "revokeBody": "ابطال اعتماد عمومی را حذف می‌کند؛ بررسی وابستگی‌ها و تأیید چندمرحله‌ای اخیر لازم است و بخشی از تعویض معمول نیست.",
    "revokeReason": "دلیل ابطال",
    "ack": "می‌دانم این کار اعتماد عمومی را حذف می‌کند و تعویض معمول کلید نیست.",
    "confirmRevoke": "تأیید ابطال",
    "blocked": "ابطال مسدود است",
    "clear": "بررسی وابستگی ابطال مانعی ندارد",
    "dependencyCount": "انتشارهای وابسته: {count}",
    "rotationBody": "ساخت ← فعال‌سازی ← تأیید جانشین در افزودن کالکتور ← بازنشستگی کلید قبلی. اعتماد تأیید انتشارهای گذشته حفظ می‌شود.",
    "staged": "آمادهٔ فعال‌سازی",
    "retired": "بازنشسته",
    "revoked": "باطل‌شده",
    "revocationPending": "در انتظار ابطال",
    "recoveryPending": "در انتظار بازیابی",
    "empty": "هنوز هویت امضای انتشار کالکتور وجود ندارد.",
    "changed": "هویت امضا به‌روز شد.",
    "error": "عملیات امضا انجام نشد.",
    "cancel": "انصراف",
    "generateTitle": "هویت آمادهٔ فعال‌سازی ساخته شود؟",
    "activateTitle": "این امضاکننده فعال شود؟"
  },
  "ar": {
    "releaseSigning": "توقيع الإصدارات",
    "evidenceWrapping": "حماية مفاتيح الأدلة",
    "description": "إدارة هويات Ed25519 لتوقيع Collector. تفعيل أدوار TUF منفصل.",
    "generate": "إنشاء هوية مرحلية",
    "activate": "تفعيل",
    "retire": "إحالة الموقّع للتقاعد",
    "eligibility": "فحص أهلية الإلغاء",
    "retireTitle": "إحالة هذا الموقّع للتقاعد؟",
    "retireBody": "يتوقف التوقيع الجديد. تبقى الإصدارات السابقة قابلة للتحقق مع الاحتفاظ بالثقة العامة.",
    "retireReason": "سبب التقاعد",
    "confirmRetire": "تأكيد التقاعد",
    "revokeTitle": "إزالة ثقة التحقق العامة؟",
    "revokeBody": "الإلغاء يزيل الثقة العامة ويتطلب فحص الاعتماديات ومصادقة متعددة العوامل حديثة؛ ليس تدويرًا اعتياديًا.",
    "revokeReason": "سبب الإلغاء",
    "ack": "أفهم أن هذا يزيل ثقة التحقق العامة وليس تدويرًا اعتياديًا.",
    "confirmRevoke": "تأكيد الإلغاء",
    "blocked": "الإلغاء محظور",
    "clear": "فحص اعتماديات الإلغاء سليم",
    "dependencyCount": "الإصدارات المعتمدة: {count}",
    "rotationBody": "إنشاء ← تفعيل ← التحقق من البديل عبر إضافة Collector ← تقاعد السابق. تبقى ثقة التحقق التاريخية.",
    "staged": "مرحلي",
    "retired": "متقاعد",
    "revoked": "ملغى",
    "revocationPending": "بانتظار الإلغاء",
    "recoveryPending": "بانتظار الاسترداد",
    "empty": "لا توجد هويات توقيع Collector بعد.",
    "changed": "تم تحديث هوية التوقيع.",
    "error": "تعذر إكمال عملية التوقيع.",
    "cancel": "إلغاء",
    "generateTitle": "إنشاء هوية مرحلية؟",
    "activateTitle": "تفعيل هذا الموقّع؟"
  },
  "it": {
    "releaseSigning": "Firma delle versioni",
    "evidenceWrapping": "Protezione chiavi delle prove",
    "description": "Gestisci le identità Ed25519 di Collector. L’attivazione dei ruoli TUF è separata.",
    "generate": "Genera identità preparata",
    "activate": "Attiva",
    "retire": "Ritira firmatario",
    "eligibility": "Verifica revocabilità",
    "retireTitle": "Ritirare questo firmatario?",
    "retireBody": "Le nuove firme si interrompono. Le versioni precedenti restano verificabili conservando la fiducia pubblica.",
    "retireReason": "Motivo del ritiro",
    "confirmRetire": "Conferma ritiro",
    "revokeTitle": "Rimuovere la fiducia pubblica?",
    "revokeBody": "La revoca rimuove la fiducia pubblica. Richiede dipendenze libere e MFA recente; non è rotazione ordinaria.",
    "revokeReason": "Motivo della revoca",
    "ack": "Comprendo che rimuove la fiducia pubblica e non è una rotazione ordinaria.",
    "confirmRevoke": "Conferma revoca",
    "blocked": "Revoca bloccata",
    "clear": "Controllo dipendenze superato",
    "dependencyCount": "Versioni dipendenti: {count}",
    "rotationBody": "Genera → Attiva → Verifica il successore con Aggiungi Collector → Ritira il precedente. La fiducia storica resta.",
    "staged": "PREPARATA",
    "retired": "RITIRATA",
    "revoked": "REVOCATA",
    "revocationPending": "REVOCA IN ATTESA",
    "recoveryPending": "RECUPERO IN ATTESA",
    "empty": "Nessuna identità di firma Collector.",
    "changed": "Identità di firma aggiornata.",
    "error": "Impossibile completare l’operazione di firma.",
    "cancel": "Annulla",
    "generateTitle": "Generare un’identità preparata?",
    "activateTitle": "Attivare questo firmatario?"
  },
  "ru": {
    "releaseSigning": "Подпись выпусков",
    "evidenceWrapping": "Защита ключей доказательств",
    "description": "Управление подписями Ed25519 Collector. Активация ролей TUF выполняется отдельно.",
    "generate": "Создать подготовленную идентичность",
    "activate": "Активировать",
    "retire": "Вывести подписанта",
    "eligibility": "Проверить возможность отзыва",
    "retireTitle": "Вывести этого подписанта?",
    "retireBody": "Новые подписи прекращаются. Проверка старых выпусков сохраняется вместе с публичным доверием.",
    "retireReason": "Причина вывода",
    "confirmRetire": "Подтвердить вывод",
    "revokeTitle": "Удалить публичное доверие?",
    "revokeBody": "Отзыв удаляет публичное доверие. Нужны проверка зависимостей и недавняя MFA; это не обычная ротация.",
    "revokeReason": "Причина отзыва",
    "ack": "Я понимаю, что публичное доверие будет удалено и это не обычная ротация.",
    "confirmRevoke": "Подтвердить отзыв",
    "blocked": "Отзыв заблокирован",
    "clear": "Проверка зависимостей пройдена",
    "dependencyCount": "Зависимые выпуски: {count}",
    "rotationBody": "Создать → Активировать → Проверить преемника через добавление Collector → Вывести предыдущего. Историческое доверие сохраняется.",
    "staged": "ПОДГОТОВЛЕНА",
    "retired": "ВЫВЕДЕНА",
    "revoked": "ОТОЗВАНА",
    "revocationPending": "ОЖИДАНИЕ ОТЗЫВА",
    "recoveryPending": "ОЖИДАНИЕ ВОССТАНОВЛЕНИЯ",
    "empty": "Идентичностей подписи Collector пока нет.",
    "changed": "Идентичность подписи обновлена.",
    "error": "Не удалось выполнить операцию подписи.",
    "cancel": "Отмена",
    "generateTitle": "Создать подготовленную идентичность?",
    "activateTitle": "Активировать подписанта?"
  },
  "es": {
    "releaseSigning": "Firma de versiones",
    "evidenceWrapping": "Protección de claves de evidencias",
    "description": "Gestiona identidades Ed25519 de Collector. La activación de roles TUF es independiente.",
    "generate": "Generar identidad preparada",
    "activate": "Activar",
    "retire": "Retirar firmante",
    "eligibility": "Comprobar revocación",
    "retireTitle": "¿Retirar este firmante?",
    "retireBody": "Se detienen las firmas nuevas. Las versiones anteriores siguen siendo verificables conservando la confianza pública.",
    "retireReason": "Motivo de retirada",
    "confirmRetire": "Confirmar retirada",
    "revokeTitle": "¿Eliminar la confianza pública?",
    "revokeBody": "La revocación elimina la confianza pública. Requiere comprobar dependencias y MFA reciente; no es rotación habitual.",
    "revokeReason": "Motivo de revocación",
    "ack": "Entiendo que elimina la confianza pública y no es una rotación habitual.",
    "confirmRevoke": "Confirmar revocación",
    "blocked": "Revocación bloqueada",
    "clear": "Comprobación de dependencias superada",
    "dependencyCount": "Versiones dependientes: {count}",
    "rotationBody": "Generar → Activar → Verificar sucesor mediante Añadir Collector → Retirar anterior. La confianza histórica se conserva.",
    "staged": "PREPARADA",
    "retired": "RETIRADA",
    "revoked": "REVOCADA",
    "revocationPending": "REVOCACIÓN PENDIENTE",
    "recoveryPending": "RECUPERACIÓN PENDIENTE",
    "empty": "Aún no hay identidades de firma Collector.",
    "changed": "Identidad de firma actualizada.",
    "error": "No se pudo completar la operación de firma.",
    "cancel": "Cancelar",
    "generateTitle": "¿Generar identidad preparada?",
    "activateTitle": "¿Activar este firmante?"
  },
  "fr": {
    "releaseSigning": "Signature des versions",
    "evidenceWrapping": "Protection des clés de preuves",
    "description": "Gérez les identités Ed25519 de Collector. L’activation des rôles TUF est distincte.",
    "generate": "Générer une identité préparée",
    "activate": "Activer",
    "retire": "Retirer le signataire",
    "eligibility": "Vérifier la révocation",
    "retireTitle": "Retirer ce signataire ?",
    "retireBody": "Les nouvelles signatures cessent. Les versions antérieures restent vérifiables avec la confiance publique conservée.",
    "retireReason": "Motif du retrait",
    "confirmRetire": "Confirmer le retrait",
    "revokeTitle": "Supprimer la confiance publique ?",
    "revokeBody": "La révocation supprime la confiance publique. Elle exige une vérification des dépendances et une MFA récente ; ce n’est pas une rotation ordinaire.",
    "revokeReason": "Motif de révocation",
    "ack": "Je comprends que la confiance publique sera supprimée et qu’il ne s’agit pas d’une rotation ordinaire.",
    "confirmRevoke": "Confirmer la révocation",
    "blocked": "Révocation bloquée",
    "clear": "Vérification des dépendances réussie",
    "dependencyCount": "Versions dépendantes : {count}",
    "rotationBody": "Générer → Activer → Vérifier le successeur via Ajouter Collector → Retirer le précédent. La confiance historique reste.",
    "staged": "PRÉPARÉE",
    "retired": "RETIRÉE",
    "revoked": "RÉVOQUÉE",
    "revocationPending": "RÉVOCATION EN ATTENTE",
    "recoveryPending": "RÉCUPÉRATION EN ATTENTE",
    "empty": "Aucune identité de signature Collector.",
    "changed": "Identité de signature mise à jour.",
    "error": "Impossible de terminer l’opération de signature.",
    "cancel": "Annuler",
    "generateTitle": "Générer une identité préparée ?",
    "activateTitle": "Activer ce signataire ?"
  },
  "de": {
    "releaseSigning": "Release-Signaturen",
    "evidenceWrapping": "Schutz von Beweisschlüsseln",
    "description": "Ed25519-Identitäten für Collector verwalten. Die Aktivierung von TUF-Rollen erfolgt separat.",
    "generate": "Vorbereitete Identität erzeugen",
    "activate": "Aktivieren",
    "retire": "Unterzeichner stilllegen",
    "eligibility": "Widerruf prüfen",
    "retireTitle": "Unterzeichner stilllegen?",
    "retireBody": "Neue Signaturen enden. Ältere Releases bleiben durch erhaltenes öffentliches Vertrauen prüfbar.",
    "retireReason": "Grund der Stilllegung",
    "confirmRetire": "Stilllegung bestätigen",
    "revokeTitle": "Öffentliches Vertrauen entfernen?",
    "revokeBody": "Ein Widerruf entfernt öffentliches Vertrauen. Abhängigkeitsprüfung und aktuelle MFA sind nötig; dies ist keine normale Rotation.",
    "revokeReason": "Widerrufsgrund",
    "ack": "Ich verstehe, dass öffentliches Vertrauen entfernt wird und dies keine normale Rotation ist.",
    "confirmRevoke": "Widerruf bestätigen",
    "blocked": "Widerruf blockiert",
    "clear": "Abhängigkeitsprüfung bestanden",
    "dependencyCount": "Abhängige Releases: {count}",
    "rotationBody": "Erzeugen → Aktivieren → Nachfolger über Collector hinzufügen prüfen → Vorgänger stilllegen. Historisches Vertrauen bleibt.",
    "staged": "VORBEREITET",
    "retired": "STILLGELEGT",
    "revoked": "WIDERRUFEN",
    "revocationPending": "WIDERRUF AUSSTEHEND",
    "recoveryPending": "WIEDERHERSTELLUNG AUSSTEHEND",
    "empty": "Noch keine Collector-Signaturidentitäten.",
    "changed": "Signaturidentität aktualisiert.",
    "error": "Signaturvorgang konnte nicht abgeschlossen werden.",
    "cancel": "Abbrechen",
    "generateTitle": "Vorbereitete Identität erzeugen?",
    "activateTitle": "Unterzeichner aktivieren?"
  },
  "tr": {
    "releaseSigning": "Sürüm imzalama",
    "evidenceWrapping": "Kanıt anahtarı koruması",
    "description": "Collector Ed25519 kimliklerini yönetin. TUF rollerinin etkinleştirilmesi ayrıdır.",
    "generate": "Hazırlanmış kimlik oluştur",
    "activate": "Etkinleştir",
    "retire": "İmzalayanı emekliye ayır",
    "eligibility": "İptal uygunluğunu denetle",
    "retireTitle": "İmzalayan emekliye ayrılsın mı?",
    "retireBody": "Yeni imzalama durur. Genel güven korunduğundan eski sürümler doğrulanabilir.",
    "retireReason": "Emeklilik nedeni",
    "confirmRetire": "Emekliliği onayla",
    "revokeTitle": "Genel doğrulama güveni kaldırılsın mı?",
    "revokeBody": "İptal genel güveni kaldırır. Bağımlılık denetimi ve yakın tarihli MFA gerekir; olağan rotasyon değildir.",
    "revokeReason": "İptal nedeni",
    "ack": "Bunun genel güveni kaldırdığını ve olağan rotasyon olmadığını anlıyorum.",
    "confirmRevoke": "İptali onayla",
    "blocked": "İptal engellendi",
    "clear": "Bağımlılık denetimi temiz",
    "dependencyCount": "Bağımlı sürümler: {count}",
    "rotationBody": "Oluştur → Etkinleştir → Collector ekleyerek halefi doğrula → Öncekini emekliye ayır. Geçmiş doğrulama güveni korunur.",
    "staged": "HAZIR",
    "retired": "EMEKLİ",
    "revoked": "İPTAL EDİLDİ",
    "revocationPending": "İPTAL BEKLİYOR",
    "recoveryPending": "KURTARMA BEKLİYOR",
    "empty": "Henüz Collector imzalama kimliği yok.",
    "changed": "İmzalama kimliği güncellendi.",
    "error": "İmzalama işlemi tamamlanamadı.",
    "cancel": "İptal",
    "generateTitle": "Hazırlanmış kimlik oluşturulsun mu?",
    "activateTitle": "İmzalayan etkinleştirilsin mi?"
  },
  "uk": {
    "releaseSigning": "Підпис випусків",
    "evidenceWrapping": "Захист ключів доказів",
    "description": "Керуйте ідентичностями Ed25519 Collector. Активація ролей TUF відбувається окремо.",
    "generate": "Створити підготовлену ідентичність",
    "activate": "Активувати",
    "retire": "Вивести підписанта",
    "eligibility": "Перевірити можливість відкликання",
    "retireTitle": "Вивести цього підписанта?",
    "retireBody": "Нові підписи припиняються. Старі випуски залишаються перевірними зі збереженням публічної довіри.",
    "retireReason": "Причина виведення",
    "confirmRetire": "Підтвердити виведення",
    "revokeTitle": "Вилучити публічну довіру?",
    "revokeBody": "Відкликання вилучає публічну довіру. Потрібні перевірка залежностей і нещодавня MFA; це не звичайна ротація.",
    "revokeReason": "Причина відкликання",
    "ack": "Я розумію, що публічна довіра буде вилучена і це не звичайна ротація.",
    "confirmRevoke": "Підтвердити відкликання",
    "blocked": "Відкликання заблоковано",
    "clear": "Перевірку залежностей пройдено",
    "dependencyCount": "Залежні випуски: {count}",
    "rotationBody": "Створити → Активувати → Перевірити наступника через додавання Collector → Вивести попередника. Історична довіра зберігається.",
    "staged": "ПІДГОТОВЛЕНА",
    "retired": "ВИВЕДЕНА",
    "revoked": "ВІДКЛИКАНА",
    "revocationPending": "ОЧІКУЄ ВІДКЛИКАННЯ",
    "recoveryPending": "ОЧІКУЄ ВІДНОВЛЕННЯ",
    "empty": "Ідентичностей підпису Collector ще немає.",
    "changed": "Ідентичність підпису оновлено.",
    "error": "Не вдалося завершити операцію підпису.",
    "cancel": "Скасувати",
    "generateTitle": "Створити підготовлену ідентичність?",
    "activateTitle": "Активувати підписанта?"
  },
  "zh-cn": {
    "releaseSigning": "版本签名",
    "evidenceWrapping": "证据密钥保护",
    "description": "管理 Collector Ed25519 签名身份。TUF 角色激活单独进行。",
    "generate": "生成暂存身份",
    "activate": "激活",
    "retire": "停用签名者",
    "eligibility": "检查撤销条件",
    "retireTitle": "停用此签名者？",
    "retireBody": "停止新的签名。保留公开信任，历史版本仍可验证。",
    "retireReason": "停用原因",
    "confirmRetire": "确认停用",
    "revokeTitle": "移除公开验证信任？",
    "revokeBody": "撤销会移除公开信任，需要依赖检查和近期多因素验证；这不是常规轮换。",
    "revokeReason": "撤销原因",
    "ack": "我理解这会移除公开验证信任，并非常规密钥轮换。",
    "confirmRevoke": "确认撤销",
    "blocked": "撤销已阻止",
    "clear": "依赖检查通过",
    "dependencyCount": "依赖版本：{count}",
    "rotationBody": "生成 → 激活 → 通过添加 Collector 验证后继者 → 停用前任。保留历史验证信任。",
    "staged": "暂存",
    "retired": "已停用",
    "revoked": "已撤销",
    "revocationPending": "等待撤销",
    "recoveryPending": "等待恢复",
    "empty": "尚无 Collector 签名身份。",
    "changed": "签名身份已更新。",
    "error": "无法完成签名操作。",
    "cancel": "取消",
    "generateTitle": "生成暂存身份？",
    "activateTitle": "激活此签名者？"
  },
  "sv": {
    "releaseSigning": "Versionssignering",
    "evidenceWrapping": "Skydd av bevisnycklar",
    "description": "Hantera Collector-identiteter med Ed25519. TUF-roller aktiveras separat.",
    "generate": "Skapa förberedd identitet",
    "activate": "Aktivera",
    "retire": "Pensionera signerare",
    "eligibility": "Kontrollera återkallelse",
    "retireTitle": "Pensionera denna signerare?",
    "retireBody": "Ny signering upphör. Äldre versioner kan fortfarande verifieras eftersom offentligt förtroende bevaras.",
    "retireReason": "Orsak till pensionering",
    "confirmRetire": "Bekräfta pensionering",
    "revokeTitle": "Ta bort offentligt förtroende?",
    "revokeBody": "Återkallelse tar bort offentligt förtroende. Beroendekontroll och aktuell MFA krävs; detta är ingen vanlig rotation.",
    "revokeReason": "Orsak till återkallelse",
    "ack": "Jag förstår att offentligt förtroende tas bort och att detta inte är vanlig rotation.",
    "confirmRevoke": "Bekräfta återkallelse",
    "blocked": "Återkallelse blockerad",
    "clear": "Beroendekontrollen godkänd",
    "dependencyCount": "Beroende versioner: {count}",
    "rotationBody": "Skapa → Aktivera → Verifiera efterträdaren via Lägg till Collector → Pensionera föregångaren. Historiskt förtroende bevaras.",
    "staged": "FÖRBEREDD",
    "retired": "PENSIONERAD",
    "revoked": "ÅTERKALLAD",
    "revocationPending": "ÅTERKALLELSE VÄNTAR",
    "recoveryPending": "ÅTERSTÄLLNING VÄNTAR",
    "empty": "Inga Collector-signaturidentiteter ännu.",
    "changed": "Signaturidentiteten uppdaterad.",
    "error": "Signeringsåtgärden kunde inte slutföras.",
    "cancel": "Avbryt",
    "generateTitle": "Skapa förberedd identitet?",
    "activateTitle": "Aktivera denna signerare?"
  }
} as const satisfies Record<InstallableLocale,Record<string,string>>;
const en = MANAGED_SIGNING_EXPERIENCE_MESSAGES.en;
export function managedSigningExperienceMessage(locale:InstallableLocale,key:keyof typeof en){return MANAGED_SIGNING_EXPERIENCE_MESSAGES[locale][key];}
type Key=keyof typeof MANAGED_SIGNING_EXPERIENCE_MESSAGES.en;
export function useManagedSigningExperienceCopy(){const {locale}=useWorkspaceCopy();return (key:Key,values?:MessageValues)=>formatMessage(MANAGED_SIGNING_EXPERIENCE_MESSAGES[locale][key],values);}
